import logoTakeOver from "../../assets/img/nxtEvents/LogoTakeOver/TakeOver.png";
import logo4Way from "../../assets/img/nxtEvents/LogoTakeOver/TakeOver4Way.png";
import logoREvolution from "../../assets/img/nxtEvents/LogoTakeOver/REvolution.png";
import logoRival from "../../assets/img/nxtEvents/LogoTakeOver/Rival.png";
import logoUnstoppable from "../../assets/img/nxtEvents/LogoTakeOver/Unstoppable.png";
import logoBrooklyn from "../../assets/img/nxtEvents/LogoTakeOver/Brooklyn.png";
import logoRespect from "../../assets/img/nxtEvents/LogoTakeOver/Respect.png";
import logoLondon from "../../assets/img/nxtEvents/LogoTakeOver/London.png";
import logoDallas from "../../assets/img/nxtEvents/LogoTakeOver/Dallas.png";
import logoTheEnd from "../../assets/img/nxtEvents/LogoTakeOver/TheEnd.png";
import logoBrooklynII from "../../assets/img/nxtEvents/LogoTakeOver/BrooklynII.png";
import logoToronto2016 from "../../assets/img/nxtEvents/LogoTakeOver/Toronto2016.png";
import logoSanAntonio from "../../assets/img/nxtEvents/LogoTakeOver/SanAntonio.png";
import logoOrlando from "../../assets/img/nxtEvents/LogoTakeOver/Orlando.png";
import logoChicago from "../../assets/img/nxtEvents/LogoTakeOver/Chicago.png";
import logoBrooklynIII from "../../assets/img/nxtEvents/LogoTakeOver/BrooklynIII.png";
import logoWarGames2017 from "../../assets/img/nxtEvents/LogoTakeOver/WarGames2017.png";
import logoPhiladelphia from "../../assets/img/nxtEvents/LogoTakeOver/Philadelphia.png";
import logoNewOrleans from "../../assets/img/nxtEvents/LogoTakeOver/NewOrleans.png";
import logoChicagoII from "../../assets/img/nxtEvents/LogoTakeOver/ChicagoII.png";
import logoBrooklynIV from "../../assets/img/nxtEvents/LogoTakeOver/BrooklynIV.png";
import logoWarGames2018 from "../../assets/img/nxtEvents/LogoTakeOver/WarGames2018.png";
import logoPhoenix from "../../assets/img/nxtEvents/LogoTakeOver/Phoenix.png";
import logoNewYork from "../../assets/img/nxtEvents/LogoTakeOver/NewYork.png";
import logoXXV from "../../assets/img/nxtEvents/LogoTakeOver/XXV.png";
import logoToronto2019 from "../../assets/img/nxtEvents/LogoTakeOver/Toronto2019.png";
import logoWarGames2019 from "../../assets/img/nxtEvents/LogoTakeOver/WarGames2019.png";
import logoPortland from "../../assets/img/nxtEvents/LogoTakeOver/Portland.png";
import logoXXX from "../../assets/img/nxtEvents/LogoTakeOver/XXX.png";
import logoInYourHouse from "../../assets/img/nxtEvents/LogoTakeOver/InYourHouse.png";
import logo31 from "../../assets/img/nxtEvents/LogoTakeOver/31.png";
import logoWarGames2020 from "../../assets/img/nxtEvents/LogoTakeOver/WarGames2020.png";
import logoVengeanceDay from "../../assets/img/nxtEvents/LogoTakeOver/VengeanceDay.png";
import logoStandAndDeliver from "../../assets/img/nxtEvents/LogoTakeOver/Stand&Deliver.png";
import logoInYourHouse2021 from "../../assets/img/nxtEvents/LogoTakeOver/InYourHouse2021.png";
import logo36 from "../../assets/img/nxtEvents/LogoTakeOver/36.png";

export const nxtTakeOverDetail = {
  "nxt-take-over": {
    id: "nxt-take-over",
    title: "NXT TakeOver",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-take-over",
        items: [
          {
            id: "nxt-take-over-1",
            title: "TakeOver",
            description: "2014",
            imgUrl: logoTakeOver,
          },
          {
            id: "nxt-take-over-fatal-4-way",
            title: "TakeOver",
            description: "Fatal 4-Way 2014",
            imgUrl: logo4Way,
          },
          {
            id: "nxt-take-over-r-evolution",
            title: "TakeOver",
            description: "R Evolution 2014",
            imgUrl: logoREvolution,
          },
          {
            id: "nxt-take-over-rival",
            title: "TakeOver",
            description: "Rival 2015",
            imgUrl: logoRival,
          },
          {
            id: "nxt-take-over-unstoppable",
            title: "TakeOver",
            description: "Unstoppable 2015",
            imgUrl: logoUnstoppable,
          },
          {
            id: "nxt-take-over-brooklyn",
            title: "TakeOver: Brooklyn",
            description: "The Battle For Brooklyn 2015",
            imgUrl: logoBrooklyn,
          },
          {
            id: "nxt-take-over-respect",
            title: "TakeOver",
            description: "Respect 2015",
            imgUrl: logoRespect,
          },
          {
            id: "nxt-take-over-london",
            title: "TakeOver: London",
            description:
              "NXT is Taking Over London for the First Time Ever! 2015",
            imgUrl: logoLondon,
          },
          {
            id: "nxt-take-over-dallas",
            title: "TakeOver",
            description: "Dallas 2016",
            imgUrl: logoDallas,
          },
          {
            id: "nxt-take-over-the-end",
            title: "TakeOver",
            description: "The End... 2016",
            imgUrl: logoTheEnd,
          },
          {
            id: "nxt-take-over-brooklyn-ii",
            title: "TakeOver",
            description: "Brooklyn II 2016",
            imgUrl: logoBrooklynII,
          },
          {
            id: "nxt-take-over-toronto",
            title: "TakeOver",
            description: "Toronto 2016",
            imgUrl: logoToronto2016,
          },
          {
            id: "nxt-take-over-san-antonio",
            title: "TakeOver",
            description: "San Antonio 2017",
            imgUrl: logoSanAntonio,
          },
          {
            id: "nxt-take-over-orlando",
            title: "TakeOver",
            description: "Orlando 2017",
            imgUrl: logoOrlando,
          },
          {
            id: "nxt-take-over-chicago",
            title: "TakeOver",
            description: "Chicago 2017",
            imgUrl: logoChicago,
          },
          {
            id: "nxt-take-over-brooklyn-iii",
            title: "TakeOver",
            description: "Brooklyn III 2017",
            imgUrl: logoBrooklynIII,
          },
          {
            id: "nxt-take-over-war-games-2017",
            title: "TakeOver: WarGames",
            description: "Houston, We Have A WarGames 2017",
            imgUrl: logoWarGames2017,
          },
          {
            id: "nxt-take-over-philadelphia",
            title: "TakeOver",
            description: "Philadelphia 2018",
            imgUrl: logoPhiladelphia,
          },
          {
            id: "nxt-take-over-new-orleans",
            title: "TakeOver",
            description: "New Orleans 2018",
            imgUrl: logoNewOrleans,
          },
          {
            id: "nxt-take-over-chicago-ii",
            title: "TakeOver",
            description: "Chicago II 2018",
            imgUrl: logoChicagoII,
          },
          {
            id: "nxt-take-over-brooklyn-iv",
            title: "TakeOver",
            description: "Brooklyn 4 2018",
            imgUrl: logoBrooklynIV,
          },
          {
            id: "nxt-take-over-war-games-2018",
            title: "TakeOver",
            description: "WarGames 2018",
            imgUrl: logoWarGames2018,
          },
          {
            id: "nxt-take-over-phoenix",
            title: "TakeOver",
            description: "Phoenix 2019",
            imgUrl: logoPhoenix,
          },
          {
            id: "nxt-take-over-new-york",
            title: "TakeOver",
            description: "New York 2019",
            imgUrl: logoNewYork,
          },
          {
            id: "nxt-take-over-xxv",
            title: "TakeOver XXV",
            description: "2019",
            imgUrl: logoXXV,
          },
          {
            id: "nxt-take-over-toronto-2019",
            title: "TakeOver",
            description: "Toronto 2019",
            imgUrl: logoToronto2019,
          },
          {
            id: "nxt-take-over-war-games-2019",
            title: "TakeOver",
            description: "WarGames 2019",
            imgUrl: logoWarGames2019,
          },
          {
            id: "nxt-take-over-portland",
            title: "TakeOver",
            description: "Portland 2020",
            imgUrl: logoPortland,
          },
          {
            id: "nxt-take-over-in-your-house-2020",
            title: "TakeOver",
            description: "In Your House 2020",
            imgUrl: logoInYourHouse,
          },
          {
            id: "nxt-take-over-xxx",
            title: "TakeOver XXX",
            description: "2020",
            imgUrl: logoXXX,
          },
          {
            id: "nxt-take-over-31",
            title: "TakeOver 31",
            description: "2020",
            imgUrl: logo31,
          },
          {
            id: "nxt-take-over-war-games-2020",
            title: "TakeOver",
            description: "WarGames 2020",
            imgUrl: logoWarGames2020,
          },
          {
            id: "nxt-take-over-vengeance-day",
            title: "TakeOver",
            description: "Vengeance Day 2021",
            imgUrl: logoVengeanceDay,
          },
          {
            id: "nxt-take-over-stand-and-deliver",
            title: "TakeOver",
            description: "Stand & Deliver 2021",
            imgUrl: logoStandAndDeliver,
          },
          {
            id: "nxt-take-over-in-your-house-2021",
            title: "TakeOver",
            description: "In Your House 2021",
            imgUrl: logoInYourHouse2021,
          },
          {
            id: "nxt-take-over-36",
            title: "TakeOver 36",
            description: "2021",
            imgUrl: logo36,
          },
        ],
      },
    ],
  },
};
